import { atom } from 'jotai';

export const dashboardHiddenSections = atom<number[]>([]);

export const dashboardContentLoading = atom<boolean>(true);
